<template>
   <div class="user_profile_wrap">
        <div class="title">{{get_local_string.string_46}}</div>

<div class="row" v-if="Object.keys(coupon_list).length > 0">
 <div class="col-xl-4 col-lg-6 col-md-6 col-12" v-for="coupon in coupon_list" :key="coupon.id">
<div class="cardWrap">
  <div class="card_cop cardLeft">
    <h1>{{coupon.title}}</h1>
    <div class="title_cop">
      <h2>{{get_local_string.string_68}}</h2>
      <span> 
         <template v-if="coupon.active_start_date">
             {{coupon.active_start_date}}
         </template>
         <template v-else>
             {{get_local_string.string_69}}
         </template>
          
          
          </span>
    </div>
    <div class="name_cop">
      <h2>{{get_local_string.string_70}}</h2>
      <span>
          <template v-if="coupon.active_end_date">
             {{coupon.active_end_date}}
         </template>
         <template v-else>
               {{get_local_string.string_69}}
         </template>
      </span>
    </div>
    
  </div>
  <div class="card_cop cardRight">
   <ion-icon name="pricetags-outline"></ion-icon>
    <div class="number_cop">
      <span>{{get_local_string.string_71}}</span>
      <h3>{{coupon.code}}</h3>
      
    </div>
  </div>

</div>
</div>
   </div>
    <div class="no_discount" v-else>
        <img src="~@/assets/gift2.svg" alt="">
        <p>{{get_local_string.string_72}}</p>
    </div>
   </div>
</template>
<script>
import { mapActions , mapGetters } from 'vuex'
export default {
     name:'discount_profile',
     data(){
         return{
             coupon_list:{}
         }
     },
     computed:{
        ...mapGetters({
         get_local_string:'get_local_string'
    })
    },
     methods:{
         ...mapActions({
             list_coupon_code_api:'list_coupon_code_api'
         })
     },
     mounted(){
         this.list_coupon_code_api().then(res=>{
             this.coupon_list = res;
             console.log(res , 'res list prof');
         });
     }
}
</script>

<style lang="scss" scoped>
$red: #f14668;
$grey: #ecedef;
$black: #343434;
.user_profile_wrap{
.title{
    font-size: 30px;
    position: relative;
    display: inline-block;
    padding-top: 10px;
    color: var(--active_color);
    border-bottom: 3px solid var(--active_color);
    padding-bottom: 6px;
    }
}
.no_discount{
    text-align: center;
    img{
        width: 550px;
    }
    p{
        color: black;
        font-size: 15px;
        font-weight: 500;
        padding-top: 20px;
    }
}

@media(max-width:767px){
    .no_discount{
    text-align: center;
    img{
        width: 350px;
    }
    p{
        color: black;
        font-size: 13px;
        font-weight: 500;
        padding-top: 20px;
    }
}
}
// card ui ux 

.cardWrap {
    display: flex;
  color: #fff;
  width: 100%;
  min-height: 210px;
}

.card_cop {
  background: linear-gradient(to bottom, $red 0%, $red 26%, $grey 26%, $grey 100%);
  height: 11em;
  float: left;
  position: relative;
  padding: 1em;

}

.cardLeft {
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
flex: 0 0 calc(100% - 104px);
}

.cardRight {
  width: 104px;
  border-left: .18em dashed #fff;
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
  text-align: center;
  ion-icon{
      font-size: 24px;
  }
  &:before,
  &:after {
    content: "";
    position: absolute;
    display: block;
    width: .9em;
    height: .9em;
    background: #fff;
    border-radius: 50%;
    left: -.5em;
  }
  &:before {
    top: -.4em;
  }
  &:after {
  bottom: -.4em;
  }
}

h1 {
  font-size: 1.1em;
  margin-top: 0;
  color: white;
  font-weight: 600;
  span {
    font-weight: normal;
  }
}

.title_cop, .name_cop, .seat_cop, .time_cop {
  text-transform: uppercase;
  font-weight: normal;
  h2 {
    font-size: .9em;
    color: #525252;
    margin: 0;
   }
  span {
    font-size: .7em;
    color: #a2aeae;
  }
}

.title_cop {
  margin: 2em 0 0 0;
}

.name_cop, .seat_cop {
  margin: .7em 0 0 0;
}

.time_cop {
  margin: .7em 0 0 1em;
}

.seat_cop, .time_cop {
  float: left;
}

.eye {
  position: relative;
  width: 2em;
  height: 1.5em;
  background: #fff;
  margin: 0 auto;
  border-radius: 1em/0.6em;
  z-index: 1;
  &:before, &:after {
    content:"";
    display: block;
    position: absolute;
    border-radius: 50%;
  }
  &:before {
    width: 1em;
    height: 1em;
    background: $red;
    z-index: 2;
    left: 8px;
    top: 4px;
  }
  &:after {
  width: .5em;
  height: .5em;
  background: #fff;
  z-index: 3;
  left: 12px;
  top: 8px;
  }
}

.number_cop {
  text-align: center;
  text-transform: uppercase;
  h3 {
    color: $red;
    font-size: 20px;
    font-weight: 700;
    
  }
  span {
    display: block;
    color: #333333;
    font-size: 14px;
     margin: 40px 0 0 0;
  }
}

</style>
